import { SVG } from '../SVG'

export const AddElectors = ({ style = {}, inactive, ...props }) => (
  <SVG
    width='24'
    height='24'
    viewBox='0 0 24 24'
    strokeWidth='1'
    strokeLinecap='round'
    xmlns='http://www.w3.org/2000/svg'
    fill='none'
    style={{ stroke: inactive ? 'var(--color-white)' : 'var(--primary-color)', ...style }}
    {...props}
  >
    <path
      d='M8 15C10.7614 15 13 12.7614 13 10C13 7.23858 10.7614 5 8 5C5.23858 5 3 7.23858 3 10C3 12.7614 5.23858 15 8 15Z'
      strokeLinejoin='round'
    />
    <path
      d='M1 19C1.87325 17.758 3.0056 16.75 4.30737 16.0557C5.60914 15.3615 7.04458 15 8.5 15C9.95542 15 11.3909 15.3615 12.6926 16.0557C13.9944 16.75 15.1267 17.758 16 19'
      strokeLinejoin='round'
    />
    <path d='M15 10.5H22' />
    <path d='M18.5 14L18.5 7' />
  </SVG>
)
